import createUrlBuilder from 'utilities/url.builder.utils';
import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest
} from 'utilities/service.utils';
import AppService from './app.service.context';
import {
  Params,
  AuthorisationAddPayload,
  AuthorisationUpdatePayload,
  AuthorisationOrderAddPayload
} from 'types';

export const fetchAuthorisations = async (params: Params) => {
  const urlBuilder = createUrlBuilder(`/community/authorisations`).toString();
  return await getRequest(AppService, urlBuilder, params);
};
export const fetchAuthorisationDetails = async (id: number) => {
  const urlBuilder = createUrlBuilder(
    `/community/authorisations/${id}`
  ).toString();
  return await getRequest(AppService, urlBuilder);
};
export const addAuthorisation = async (payload: AuthorisationAddPayload) => {
  const urlBuilder = createUrlBuilder(`/community/authorisations`).toString();
  return await postRequest(AppService, urlBuilder, payload);
};
export const updateAuthorisation = async (
  id: number,
  payload: AuthorisationUpdatePayload
) => {
  const urlBuilder = createUrlBuilder(
    `/community/authorisations/${id}`
  ).toString();
  return await putRequest(AppService, urlBuilder, payload);
};
export const deleteAuthorisation = async (id: number) => {
  const urlBuilder = createUrlBuilder(
    `/community/authorisations/${id}`
  ).toString();
  return await deleteRequest(AppService, urlBuilder);
};
export const addAuthorisationOrder = async (
  id: number,
  payload: AuthorisationOrderAddPayload
) => {
  const urlBuilder = createUrlBuilder(
    `/community/authorisations/${id}/order`
  ).toString();
  return await postRequest(AppService, urlBuilder, payload);
};
export const deleteAuthorisationOrder = async (
  authorisationId: number,
  orderId: number
) => {
  const urlBuilder = createUrlBuilder(
    `/community/authorisations/${authorisationId}/order/${orderId}`
  ).toString();
  return await deleteRequest(AppService, urlBuilder);
};
export const fetchAuthorisationTypes = async () => {
  const urlBuilder = createUrlBuilder(`/system/domains/AUTHORISATION_TYPES`);
  return await getRequest(AppService, urlBuilder.toString());
};
export const purchaseAuthorisation = async (
  payload: AuthorisationAddPayload
) => {
  const urlBuilder = createUrlBuilder(
    `/community/authorisations/purchase`
  ).toString();
  return await postRequest(AppService, urlBuilder, payload);
};
export const purchaseAuthorisationOrder = async (
  id: number,
  payload: AuthorisationOrderAddPayload
) => {
  const urlBuilder = createUrlBuilder(
    `/community/authorisations/${id}/order/purchase`
  ).toString();
  return await postRequest(AppService, urlBuilder, payload);
};
